/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
var PropertyTab = function ( editor ) {

	var signals = editor.signals;

	var container = new UI.Panel();
	container.setId( 'propertyTab' );

	var selected = null;
	var values;


	// Animation editor default values
	var animationEditorIndex = 1
	var defaultAnimationIndex = 0

	// default position of origin and Rotation of origin
	const defaultPosition = [0, 0, 0]
	const defaultRotation = [0, 0, 0]


	function build() {

		container.clear();

		if ( selected === null ) return;

		values = {};

		// Time

		var row = new UI.Row();
		row.add(new UI.Text('Time').setWidth('45px'));
		container.add(row);

		var animationStart = new UI.Number(selected.start).setWidth('45px');
		animationStart.onChange(function () {

			selected.start = this.getValue();
			signals.animationModified.dispatch(selected);

		});
		row.add(animationStart);
		var animationEnd = new UI.Number(selected.end).setWidth('45px');
        animationEnd.onChange(function () {

            selected.end = this.getValue();
            signals.animationModified.dispatch(selected);

        });
        row.add(animationEnd);
		// Name 

		var row = new UI.Row();
		row.add(new UI.Text('Name').setWidth('180px'));
		container.add(row);

		var input = new UI.Input(selected.name);
		input.onChange(function () {
			let val = this.getValue()
			selected.name = val
			signals.animationModified.dispatch(selected);
		});
		row.add(input);

		//Position of origin

		var row = new UI.Row();
		row.add(new UI.Text('Position of origin').setWidth('180px'));
		container.add(row);

		var [x, y, z] = selected.origin.position

		var input = new UI.Input(`(${x}, ${y}, ${z})`);
		input.onChange(function () {

			let val = this.getValue().substring(1, this.getValue().length - 1)
			let position = val.split(',').map(s => parseFloat(s.trim()))

			// prevent model position from going below floor
			if (position[1] < 0) {
				position[1] = 0
			}
			selected.origin.position[0] = position[0]
			selected.origin.position[1] = position[1]
			selected.origin.position[2] = position[2]
			signals.animationModified.dispatch(selected);

		});
		row.add(input);

		//Reset Position of origin
		var row = new UI.Row();
		var button = new UI.Button('Reset Position').setWidth('72%').setPadding('10px 0').setBorderRadius('8px').setBackgroundColor('#121212')
		button.onClick(function () {
			selected.origin.position[0] = defaultPosition[0]
			selected.origin.position[1] = defaultPosition[1]
			selected.origin.position[2] = defaultPosition[2]
			signals.animationModified.dispatch(selected);
		});
		row.add(button);

		container.add(row);

		//Rotation of origin

		var row = new UI.Row();
		row.add(new UI.Text('Rotation of origin').setWidth('180px'));
		container.add(row);

		var [x, y, z] = selected.origin.rotation

		var input = new UI.Input(`(${x}, ${y}, ${z})`);
		input.onChange(function () {
			let val = this.getValue().substring(1, this.getValue().length - 1)
			let rotation = val.split(',').map(s => parseFloat(s.trim()))
			selected.origin.rotation[0] = rotation[0]
			selected.origin.rotation[1] = rotation[1]
			selected.origin.rotation[2] = rotation[2]
			signals.animationModified.dispatch(selected);

		});
		row.add(input);

		//Reset Rotation of origin
		var row = new UI.Row();
		var button = new UI.Button('Reset Rotation').setWidth('72%').setPadding('10px 0').setBorderRadius('8px').setBackgroundColor('#121212')
		button.onClick(function () {
			selected.origin.rotation[0] = defaultRotation[0]
			selected.origin.rotation[1] = defaultRotation[1]
			selected.origin.rotation[2] = defaultRotation[2]
			signals.animationModified.dispatch(selected);
		});
		row.add(button);

		container.add(row);

		//Position of destination

		var row = new UI.Row();
		row.add(new UI.Text('Position of destination').setWidth('180px'));
		container.add(row);

		var [x, y, z] = selected.destination.position

		var input = new UI.Input(`(${x}, ${y}, ${z})`);
		input.onChange(function () {
			let val = this.getValue().substring(1, this.getValue().length - 1)
			let position = val.split(',').map(s => parseFloat(s.trim()))
			selected.destination.position[0] = position[0]
			selected.destination.position[1] = position[1]
			selected.destination.position[2] = position[2]
			signals.animationModified.dispatch(selected);

		});
		row.add(input);

		//Rotation of destination

		var row = new UI.Row();
		row.add(new UI.Text('Rotation of destination').setWidth('180px'));
		container.add(row);

		var [x, y, z] = selected.destination.rotation

		var input = new UI.Input(`(${x}, ${y}, ${z})`);
		input.onChange(function () {
			let val = this.getValue().substring(1, this.getValue().length - 1)
			let rotation = val.split(',').map(s => parseFloat(s.trim()))
			selected.destination.rotation[0] = rotation[0]
			selected.destination.rotation[1] = rotation[1]
			selected.destination.rotation[2] = rotation[2]

		});
		row.add(input);
		
		// Animation

		var row = new UI.Row();
		row.add(new UI.Text('Animation').setWidth( '180px' ) );
		container.add( row );

		//AnimationSelection

		var row = new UI.Row();
		container.add( row );
		var animationVoice = new UI.Select()
	
		animationVoice.setOptions( editor.animationItems.map((animationItem, i) => animationItem.name) ).setValue( 0 );
		animationVoice.onChange( function () {

			selected.voice = this.getValue();
			signals.animationRenamed.dispatch( selected );

		} );

		row.add( animationVoice );

		// Animation
		var row = new UI.Row();
		var button = new UI.Button('Add Animation').setWidth('100%')

		button.onClick(function () {
			let addedElement = _addNewAnimationElement(selected)
			createAnimationEditor(container, addedElement)
		});
		row.add(button);
		container.add(row);


		selected.elements.forEach((element) => {
			if (element.animation) {
				createAnimationEditor(container, element)
			}
		})

	}

	function createAnimationEditor(container, currentElement) {

		// Select Animation
		var row = new UI.Row();
		row.add(new UI.Text('Animation ' + animationEditorIndex).setWidth('90px'));
		container.add(row);

		var row = new UI.Row();
		row.add(new UI.Text('Animation Selector').setWidth('180px'));
		container.add(row);

		var animation = new UI.Select()
		let animationIndex = editor.animationItems.findIndex(animationItem => animationItem.name === currentElement.animation.name)
		animation.setOptions(editor.animationItems.map((animationItem, i) => animationItem.name)).setValue(animationIndex);
		animation.onChange(function (e) {

			let changedAnimationSelectionIndex = this.getValue()
			let newName = editor.animationItems[parseInt(changedAnimationSelectionIndex)].name
			currentElement.animation.name = newName

		});
		row.add(animation);

		//Enter Animation Start
		var row = new UI.Row();
		row.add(new UI.Text('Animation Start').setWidth('180px'));
		container.add(row);

		var animationStart = new UI.Number(currentElement.animation.startTime).setWidth('45px');
		animationStart.onChange(function (e) {

			let animationStartTime = this.getValue();
			currentElement.animation.startTime = animationStartTime

		});
		row.add(animationStart);

		//Enter Animation End
		var row = new UI.Row();
		row.add(new UI.Text('Animation End').setWidth('180px'));
		container.add(row);

		var animationEnd = new UI.Number(currentElement.animation.endTime).setWidth('45px');
		animationEnd.onChange(function (e) {

			let animationEndTime = this.getValue();
			currentElement.animation.endTime = animationEndTime

		});
		row.add(animationEnd);

		//Animation Position of destination

		var row = new UI.Row();
		row.add(new UI.Text('Animation Position of destination').setWidth('180px'));
		container.add(row);

		var [x, y, z] = currentElement.animation.destination.position

		var input = new UI.Input(`(${x}, ${y}, ${z})`);
		input.onChange(function () {
			let val = this.getValue().substring(1, this.getValue().length - 1)
			let position = val.split(',').map(s => parseInt(s.trim()))
			currentElement.animation.destination.position[0] = position[0]
			currentElement.animation.destination.position[1] = position[1]
			currentElement.animation.destination.position[2] = position[2]

		});
		row.add(input);

		//Animation Rotation of destination

		var row = new UI.Row();
		row.add(new UI.Text('Animation Rotation of destination').setWidth('180px'));
		container.add(row);

		var [x, y, z] = currentElement.animation.destination.rotation

		var input = new UI.Input(`(${x}, ${y}, ${z})`);
		input.onChange(function () {
			let val = this.getValue().substring(1, this.getValue().length - 1)
			let rotation = val.split(',').map(s => parseInt(s.trim()))
			currentElement.animation.destination.rotation[0] = rotation[0]
			currentElement.animation.destination.rotation[1] = rotation[1]
			currentElement.animation.destination.rotation[2] = rotation[2]

		});
		row.add(input);

		// increment for new voice editor
		animationEditorIndex++

	}


	function _addNewAnimationElement(selected) {
		let elementToAdd = {
			animation: {
				name: editor.animationItems[defaultAnimationIndex].name,
				startTime: 0,
				endTime: 0,
				destination: {
					position: defaultPosition,
					rotation: defaultRotation
				},
				elements: []
			}
		}
		selected.elements.push(elementToAdd)
		return elementToAdd
	}

	//

	// signals.editorCleared.add( function () {

	// 	selected = null;
	// 	build();

	// } );

	signals.animationSelected.add( function ( animation ) {
	
		selected = animation;
		build();
	} );

	signals.animationModified.add(function (animation) {
		selected = animation;
		build();
	});


	signals.effectCompiled.add( build );

	/*
	signals.timeChanged.add( function () {

		if ( selected !== null ) {

			for ( var key in values ) {

				values[ key ].setValue( selected.module.parameters[ key ].value );

			}

		}

	} );
	*/

	return container;

};

export default PropertyTab


//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/PropertyTab.js
// module id = null
// module chunks = 